import * as React from 'react';

import {Email} from 'shells/entity/entity-display-values/email';

import styles from './cell.module.css';

type Props = {
    value: string | null | undefined;
    entityId: string | null | undefined;
    isHidden?: boolean;
};

export function CellEmail(props: Props) {
    return props.value && props.entityId ? (
        <div title={props.isHidden ? undefined : props.value} className={styles['cell-content']}>
            <Email value={props.value} entityId={props.entityId} />
        </div>
    ) : null;
}
